<template>
  <Typography v-if="claim.customer" variant="body-2">Customer: {{ claim.customer }}</Typography>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";

export default {
  name: "ClaimCustomer",
  components: {
    Typography,
  },
  props: {
    claim: {
      type: Object,
      required: true,
    },
  },
};
</script>
